import * as React from 'react';

import { withRouter } from 'app/context/Router';

import Button from 'components/Button';
import Icon from 'components/Icon';
import Link from 'components/Link';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import TitleHeader from 'components/TitleHeader';
// @ts-ignore
import View from 'components/View';
// @ts-ignore
import Views from 'components/Views';

import PendingMembershipsTableContainer from 'groupMembershipRequests/containers/PendingMembershipsTableContainer';
import { RouterState } from 'lib/ReactRouterTypes';

type Props = {
  groupUuid: string;
  groupCode: string;
  router: RouterState;
};

class PendingMembershipsList extends React.Component<Props> {
  renderPageHeader() {
    const { groupCode, router } = this.props;

    return (
      <MediaObject className="PendingMemberships-header">
        <Button
          className="PendingMemberships-backButton"
          level="icon"
          weight="semibold"
          aria-label="Back"
          to={router.location.pathname.replace('pending_memberships', '')}>
          <Icon name="arrow-left" color="brand" />
        </Button>
        <TitleHeader
          className="PendingMemberships-title"
          title="Pending requests"
          subtext={
            <Text>
              Review people requesting to join your class. To let people join without approval,
              change the{' '}
              <Link
                to={`/classes/${groupCode}/class_settings`}
                className="PendingMemberships-classSetting"
                eventElementName="PendingMemberships-classSetting">
                class setting
              </Link>
              .
            </Text>
          }
          textAlign="left"
        />
      </MediaObject>
    );
  }

  render() {
    const { groupUuid } = this.props;

    return (
      <Views className="PendingMemberships">
        <View className="PendingMemberships-body" gutter="small" scroll>
          <PendingMembershipsTableContainer
            groupUuid={groupUuid}
            pageHeader={this.renderPageHeader()}
            pageHeaderHeight={113}
          />
        </View>
      </Views>
    );
  }
}

export default withRouter(PendingMembershipsList);
